import React, { useState, useEffect } from 'react';
import { func, object, array, bool, any, number } from 'prop-types';
import Icon from '@sabre/spark-react-core/icon';
import { Popover } from 'react-tiny-popover';
import TextInput from '@sabre/spark-react-core/text-input';
import Tooltip from '@sabre/spark-react-core/tooltip';
import Checkbox from '@sabre/spark-react-core/checkbox';
import Button from '@sabre/spark-react-core/button';
const TableHeader = ({ handleEnablesHeadersControls,
    handleSorting,
    handleUniqueItemClick,
    filterUniqueValues,
    handleShowSearchFilters,
    handleFilterChange,
    item,
    headerData,
    rowData,
    isScroll,
    isMultiFilter,
    isToolTipShow,
    handleSelectAllUpdate,
    handleClearEvent,
    handleFilterUniqueItems }) => {
    const [selectAll, setSelectAll] = useState(false);
    const [tableHeaderConfig, setTableHeaderConfig] = useState({
        isShowFilterControls: item.isShowFilterControls,
        isFilterOpen: item.isFilterOpen,
        filterUniqueValues: item.filterUniqueValues
    });
    useEffect(() => {
        setTableHeaderConfig({ ...tableHeaderConfig, filterUniqueValues: item.filterUniqueValues })
    }, [item.filterUniqueValues])

    const handleSelectAllClick = (item) => {
        setSelectAll(!selectAll);
        const updatedResult = tableHeaderConfig.filterUniqueValues.map(list => {
            list.value = !selectAll;
            return list;
        });
        setTableHeaderConfig({
            ...tableHeaderConfig,
            filterUniqueValues: updatedResult
        })
        // handleSelectAllUpdate(!selectAll, isScroll, item);
    };
    const handleShowControls = (item) => {
        if (item.key === 'fav' || rowData.length === 0)
            return;
        setTableHeaderConfig({ ...tableHeaderConfig, isShowFilterControls: true, isFilterOpen: false });
    }
    const handleHideControls = () => {
        if (!tableHeaderConfig.isFilterOpen)
            setTableHeaderConfig({ ...tableHeaderConfig, isShowFilterControls: false });
    }
    const handleShowFilter = () => {
        if (rowData.length === 0)
            return;
        setTableHeaderConfig({ ...tableHeaderConfig, isFilterOpen: true })
    }
    const handleHideFilter = () => {
        setTableHeaderConfig({ ...tableHeaderConfig, isFilterOpen: false, isShowFilterControls: false })
    }
    const handleFilterUniqueItemsColumn = (item, isScroll) => {
        console.log(item, 'item')
    }
    const handleUniqueItem = (subItem) => {
        const updateResult = tableHeaderConfig.filterUniqueValues.map((item) => {
            if (item.key === subItem.key)
                item.value = !item.value;
            return item;
        });
        setTableHeaderConfig({
            ...tableHeaderConfig,
            filterUniqueValues: updateResult
        });
    }
    const formatHeader = (headerValue) => headerValue.replace(/([A-Z])/g, ' $1').trim();
    useEffect(() => {
        if (item.filterUniqueValues) {
            const isSelectAll = item.filterUniqueValues.every(subList => subList.value === true);
            isSelectAll ? setSelectAll(true) : setSelectAll(false);
        }

    }, [headerData])
    return (
        <div className={`custom-cell spark-flex ${!isScroll && item.key.length < 4 ? 'spark-mar-l-.5' : ''}`}
            onMouseEnter={() => handleShowControls(item)}
            onMouseLeave={handleHideControls}
        //    onMouseLeave={() => handleEnablesHeadersControls(item, headerData, isScroll, true,'closeHeader')}
        >
            {
                isToolTipShow ? <Tooltip
                    anchorY='top'
                    anchorX='center'
                    toggleEl={<div data-testid={`header-${item.key}-id`}>{formatHeader(item.key)}</div>
                    }
                >{item.title}
                </Tooltip> : <div data-testid={`header-${item.key}-id`}>{formatHeader(item.key)}</div>
            }
            <span>
                {
                    tableHeaderConfig.isShowFilterControls && <div className='header-icon spark-flex'>
                        {
                            (item.isDefault || item.isDecending) ? <Icon name='arrow-triangle-up'
                                size='md'
                                style='fill'
                                onClick={() => handleSorting(item)}
                                label='Show Stored Criteria' /> :
                                item.isAscending && <Icon name='arrow-triangle-down'
                                    size='md'
                                    style='fill'
                                    onClick={() => handleSorting(item)}
                                    label='Show Stored Criteria' />
                        }


                        <Popover
                            isOpen={tableHeaderConfig.isFilterOpen}
                            positions={['bottom']}
                            containerClassName={` ${isMultiFilter ? 'pop-bg-multi' : 'pop-bg'}`}
                            onClickOutside={handleHideFilter}
                            padding={3}
                            content={<div className='full-height'
                                onMouseEnter={handleShowFilter}
                            >
                                {/* <input type='text' placeholder={`Search ${item.key}`} value={item.filterValue} onChange={(event) => handleFilterChange(event.target.value, item, rowData)} /> */}
                                <TextInput
                                    className='spark-pad-l-.5'
                                    name={`Search ${item.key}`}
                                    placeholder={`Search ${item.key}`}
                                    value={item.filterValue}
                                    onChange={(event, selectedValue) => handleFilterChange(selectedValue, item, rowData)} />
                                {
                                    isMultiFilter && item.filterUniqueValues.length > 0 && <div> <div className='full-height-button'>
                                        <div className='row'>
                                            <div>
                                                <Checkbox className='spark-bold spark-align-items-center' label='Select All' checked={selectAll} onChange={() => handleSelectAllClick(item)} />
                                                {/* <input type='checkbox' checked={selectAll} onChange={() => handleSelectAllClick(item)} /> */}
                                            </div>
                                            {/* <div className='pop-bg-multi-check-box-label spark-bold'>Select All</div> */}
                                        </div>
                                        <div className={` ${item.filterUniqueValues.length > 4 ? 'popup-checkbox-content' : 'popup-checkbox-min-content'} table-view-auto-x-scroll`}>
                                            {
                                                tableHeaderConfig.filterUniqueValues.map((subItem, index) => {
                                                    return <Checkbox key={index} className='spark-bold spark-align-items-center' label={subItem.key} checked={subItem.value} onChange={() => handleUniqueItem(subItem)} />
                                                })
                                            }
                                        </div>
                                    </div>

                                        <div className='row popup-up-controls'>
                                            <Button
                                                className='spark-btn-group-secondary select-button-cancel popup-up-controls-ok-button'
                                                size='xs'
                                                primary='true'
                                                disabled={item.filterUniqueValues.every(item => !item.value)}
                                                onClick={() => handleFilterUniqueItems(item, isScroll)}
                                            >
                                                Apply
                                            </Button>
                                            <Button
                                                className='spark-btn-group-primary'
                                                size='xs'
                                                secondary='true'
                                                onClick={() => handleClearEvent(item, headerData, isScroll, true)}
                                            >
                                                Clear
                                            </Button>
                                        </div>
                                    </div>
                                }
                            </div>}
                        >
                            <div >
                                {
                                    !item.isFilterApply && <Icon name='menu-hamburger'
                                        onClick={handleShowFilter}
                                        size='md'
                                        style='fill'
                                        label='Show Stored Criteria' />
                                }
                            </div>
                        </Popover>

                    </div>
                }
            </span>
            {item.isFilterApply && <div className='edit-icon spark-pad-l-.5'>
                <Icon name='pencil'
                    onClick={handleShowFilter}
                    size='md'
                    style='fill'
                    label='Show Stored Criteria' />
            </div>
            }
        </div>

    )
};
TableHeader.propTypes = {
    handleEnablesHeadersControls: func,
    handleSorting: func,
    handleShowSearchFilters: func,
    handleFilterChange: func,
    handleUniqueItemClick: func,
    handleSelectAllUpdate: func,
    handleClearEvent: func,
    handleFilterUniqueItems: func,
    item: object,
    headerData: array,
    filterUniqueValues: array,
    rowData: array,
    isScroll: bool,
    isMultiFilter: bool,
    isToolTipShow: bool
}
export default TableHeader;